// FLAG:useDocuAi — fingerprint of a document's artifact set (DMS invoice relations + legacy
// generated files + the validity result). The preview re-resolves the artifacts for a short window
// after the document was opened, because DocuAI's children are linked AFTER the DMS reports the
// analysis ready; this signature is how that refresh decides "something new arrived, keep going" vs
// "settled, stop". Deliberately dependency-free so it stays unit-testable — importing it must not
// drag in fileService and with it the whole redux store.
export interface ArtifactFields {
  invoiceRelatedFiles?: unknown[]
  generatedFiles?: unknown[]
  validationResult?: Record<string, unknown>
}

export const artifactSignature = (source?: ArtifactFields | null): string => {
  if (!source) return ''
  const ids = [
    ...((source.invoiceRelatedFiles || []) as Array<{ id?: unknown, dmsVersionId?: unknown }>),
    ...((source.generatedFiles || []) as Array<{ id?: unknown, dmsVersionId?: unknown }>),
  ].map(file => String(file?.dmsVersionId ?? file?.id ?? ''))
  ids.sort()
  return `${ids.join('|')}#${source.validationResult ? 'v' : ''}`
}

export default artifactSignature
